import styled from "styled-components";
import { styledMedia } from "../../../components/mediaquery/breakpoints";

export const HEIGHT = "80px";

export const getBackgroundColor = theme => {
  return theme.color.base.getShade(9);
};

export const BaseContainer = styled.div`
  background: ${props => getBackgroundColor(props.theme)};
  bottom: 0;
  color: #fff;
  height: ${HEIGHT};
  left: ${props => props.offset}px;
  min-height: ${HEIGHT};
  position: fixed;
  width: 100%;
  z-index: 2;
  padding: 0 50px;

  ${styledMedia.medium`
    padding: 0 30px;
  `}
    
  ${styledMedia.small`
    display: none !important;
  `}
`;
